'use client'
import React from 'react'
import CallIcon from '@local/assets/svgs/call.svg'
import {usePathname} from 'next/navigation'
import {cx} from '@local/utils/cx'
export const Whatsapp = () => {
	const pathname = usePathname()
	const showAbove = pathname.includes('stay/') || pathname.includes('experience/')
	return (
		<button
			onClick={() => window.open('https://wa.me/+31616598238', '_blank')}
			className={cx(
				'bg-black w-50 h-50 z-1 fixed bottom-10 right-10 rounded-full p-10',
				showAbove && 'bottom-80 z-0',
			)}>
			<CallIcon className='w-full h-full' />
		</button>
	)
}
